import { Directive, effect, inject, input, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserInfoService } from '../../features/user/services/user-info.service';
import { UserInfoAuthorizationInformation } from '../../core/clients/omni-core/models';

@Directive({
  selector: '[notHasRole]',
})
export class NotHasRoleDirective {
  private templateRef = inject(TemplateRef<HTMLElement>);
  private viewContainer = inject(ViewContainerRef);
  private userInfoService = inject(UserInfoService);

  notHasRole = input.required<
    UserInfoAuthorizationInformation['role'] | UserInfoAuthorizationInformation['role'][]
  >();

  private hasView = false;

  constructor() {
    effect(() => {
      const role = this.userInfoService.info()?.role;
      const notHasRole = this.notHasRole();
      const forbiddenRoles = Array.isArray(notHasRole) ? notHasRole : [notHasRole];
      if (!role || !forbiddenRoles.includes(role)) {
        this.render();
      } else {
        this.destroy();
      }
    });
  }

  private render(): void {
    if (this.hasView) {
      return;
    }
    this.viewContainer.createEmbeddedView(this.templateRef);
    this.hasView = true;
  }

  private destroy(): void {
    if (!this.hasView) {
      return;
    }
    this.viewContainer.clear();
    this.hasView = false;
  }
}
